import {FormControl} from '@angular/forms';
import {isNil} from 'lodash-es';

export function validInteger(control: FormControl) {
  return check_if_is_integer(control.value) || isNil(control.value) || control.value === '' ? null : {
    validInteger: {
      valid: false,
    },
  };
}

function check_if_is_integer(value) {
  // eslint-disable-next-line radix
  return ((parseFloat(value) === parseInt(value)) && !isNaN(value));
}

export function positiveInteger(control: FormControl) {
  return check_if_is_positive_integer(control.value) || isNil(control.value) || control.value === '' ? null : {
    positiveInteger: {
      valid: false,
    },
  };
}

export function positiveIntegerOrZero(control: FormControl) {
  return check_if_is_positive_integer(control.value) || isNil(control.value) || control.value === '' || control.value === 0 ? null : {
    positiveIntegerOrZero: {
      valid: false,
    },
  };
}

function check_if_is_positive_integer(value) {
  return check_if_is_integer(value) && value > 0;
}
